import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Row, Col } from 'react-bootstrap';
import { collection, addDoc, getDocs, where, query, doc, updateDoc } from "firebase/firestore";
import { auth, db, storage } from "../firebase";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import ReactMarkdown from 'react-markdown';

function Admin() {
  var navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [postEn, setPostEn] = useState("");
  const [postNp, setPostNp] = useState("");
  const [image, setImage] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [fileName, setFileName] = useState("");
  const [Category, setCategory] = useState("");
  const [hastranslation, setHasTranslation] = useState(false);

  const successNotification = () => toast.success("Successfully Posted");
  const failureNotification = () => toast.error("Only Admin can post the blog");

  function dataURLtoBlob(dataURL) {
    var parts = dataURL.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);
    for (var i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const isImage = file.type.startsWith("image/");
      const maxFileSize = 5 * 1024 * 1024;
      if (!isImage) { toast.error("Please upload a valid image file"); return; }
      if (file.size > maxFileSize) { toast.error("Image size must be under 5MB"); return; }
      setFileName(file.name);
      var reader = new FileReader();
      reader.onload = function () {
        try {
          setImage(dataURLtoBlob(reader.result));
        } catch (error) {
          console.error("Error reading file:", error);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (!auth.currentUser?.uid) return;
      try {
        const q = query(collection(db, "users"), where("uid", "==", auth.currentUser.uid));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          setIsAdmin(querySnapshot.docs[0].data().isAdmin);
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      }
    };
    fetchUserData();
  }, []);

  const blogs = async () => {
    try {
      if (isAdmin) {
        let imageUrl = null;
        if (image) {
          const imageRef = ref(storage, `images/${fileName}`);
          await uploadBytes(imageRef, image);
          imageUrl = await getDownloadURL(imageRef);
        }

        const docRef = await addDoc(collection(db, "blog"), {
          title,
          postEn,
          postNp: hastranslation ? postNp : "",
          hastranslation,
          imageUrl,
          author: { name: auth.currentUser.displayName },
          Date: new Date().toISOString().slice(0, 10),
          Category,
        });
        await updateDoc(doc(db, "blog", docRef.id), { blogId: docRef.id });

        successNotification();
        navigate("/");
      } else {
        failureNotification();
      }
    } catch (error) {
      console.error("Error adding blog post: ", error);
    }
  };

  const previewBoxStyle = {
    border: '1px solid #ccc',
    padding: '12px',
    borderRadius: '5px',
    minHeight: '160px',
  };

  const npStyle = {
    fontFamily: "'Noto Sans Devanagari', 'Arial Unicode MS', sans-serif",
  };

  return (
    <div style={{ maxWidth: hastranslation ? '1100px' : '520px', margin: 'auto', marginTop: '40px', padding: '20px', transition: 'max-width 0.3s ease' }}>
      <Form>
        <Form.Group className="mb-3" controlId="formBasicTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control type="text" placeholder="Enter title" value={title} onChange={(e) => setTitle(e.target.value)} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicCategory">
          <Form.Label>Category</Form.Label>
          <Form.Control type="text" placeholder="Enter Category" value={Category} onChange={(e) => setCategory(e.target.value)} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formHasTranslation">
          <Form.Check
            type="checkbox"
            label="Has Nepali version (नेपाली संस्करण छ)"
            checked={hastranslation}
            onChange={(e) => setHasTranslation(e.target.checked)}
          />
        </Form.Group>

        {hastranslation ? (
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formBasicPostEn">
                <Form.Label>Post — English</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={12}
                  placeholder="Write your post in English..."
                  value={postEn}
                  onChange={(e) => setPostEn(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formBasicPostNp">
                <Form.Label>Post — नेपाली</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={12}
                  placeholder="यहाँ नेपालीमा लेख्नुहोस्..."
                  value={postNp}
                  onChange={(e) => setPostNp(e.target.value)}
                  style={npStyle}
                />
              </Form.Group>
            </Col>
          </Row>
        ) : (
          <Form.Group className="mb-3" controlId="formBasicPost">
            <Form.Label>Tell me your Story</Form.Label>
            <Form.Control
              as="textarea"
              rows={7}
              placeholder="Enter your post"
              value={postEn}
              onChange={(e) => setPostEn(e.target.value)}
            />
          </Form.Group>
        )}

        <Form.Group className="mb-3" controlId="formBasicImage">
          <Form.Label>Upload Image</Form.Label>
          <Form.Control type="file" onChange={handleImageUpload} />
        </Form.Group>

        <Button variant="success" size="sm" onClick={blogs}>
          Submit
        </Button>
      </Form>

      {(postEn || postNp) && (
        <div style={{ marginTop: '30px' }}>
          <h5>Live Preview</h5>
          {hastranslation ? (
            <Row>
              <Col md={6}>
                <p style={{ color: '#888', marginBottom: '6px', fontWeight: 500 }}>English</p>
                <div style={previewBoxStyle}>
                  <ReactMarkdown>{postEn}</ReactMarkdown>
                </div>
              </Col>
              <Col md={6}>
                <p style={{ color: '#888', marginBottom: '6px', fontWeight: 500 }}>नेपाली</p>
                <div style={{ ...previewBoxStyle, ...npStyle }}>
                  <ReactMarkdown>{postNp}</ReactMarkdown>
                </div>
              </Col>
            </Row>
          ) : (
            <div style={previewBoxStyle}>
              <ReactMarkdown>{postEn}</ReactMarkdown>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Admin;
